import React, { useState, useEffect } from 'react';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language?.substring(0, 2) || 'en');
  
  // Update current language state when i18n language changes
  useEffect(() => {
    setCurrentLang(i18n.language?.substring(0, 2) || 'en');
  }, [i18n.language]);
  
  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    // Store the language preference in localStorage
    localStorage.setItem('i18nextLng', lang);
    setCurrentLang(lang);
  };

  const items = [
    {
      key: 'en',
      label: t('languageSwitcher.en'),
      onClick: () => changeLanguage('en'),
    },
    {
      key: 'ru',
      label: t('languageSwitcher.ru'),
      onClick: () => changeLanguage('ru'),
    },
  ];

  // Get the language code display in uppercase
  const getLangDisplay = () => {
    return currentLang.toUpperCase();
  };

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomRight"
      arrow
    >
      <Button 
        type="text"
        icon={<GlobalOutlined />}
        style={{ marginRight: 8 }}
      >
        {getLangDisplay()}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher; 